import WebConstant from "../../webConstants";
import { mainWrapper } from "../../main";


function permissionsListing () {
    return mainWrapper.get(WebConstant.host + `/permission`, );
};


export const permissionsServices = {
    permissionsListing
};
